import { inject, Injectable } from '@angular/core';
import { AjaxResponse } from 'rxjs/ajax';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { BaseRequester } from '../../../shared/services/common/base-requester';
import { UnifiedQueryV2Service } from 'src/app/shared/services';
import { map as _map, uniq as _uniq } from 'lodash';
import { map } from 'rxjs/operators';
@Injectable({
    providedIn: 'root',
})
export class ItemMarkService extends BaseRequester {
    MARK_KEY = 'mark1';
    constructor() {
        super();
    }

    private unifiedQueryV2Service = inject(UnifiedQueryV2Service);

    getMarked(mark = true): Observable<number[]> {
        return this.unifiedQueryV2Service
            .query({
                db: 'management-console',
                col: 'item_mark',
                query: {
                    key: this.MARK_KEY,
                    mark,
                },
                options: {
                    projection: {
                        _id: 0,
                        pid: 1,
                        key: 1,
                    },
                },
            })
            .pipe(
                map((results: any[]) => {
                    const pids = _map(results, 'pid');
                    return _uniq(pids);
                }),
            );
    }

    mark(pids: number[], mark = true): Observable<boolean> {
        return this.internalPostRequest<ItemMarkRequest>(
            environment.inventoryMarkEndpoint,
            {
                key: this.MARK_KEY,
                mark,
                pids,
            },
        ).pipe(
            map((response: AjaxResponse) => {
                if (response.status === 200) {
                    return response.response;
                } else {
                    throw new Error(
                        `Failed with status: ${response.status}, ${response.response.message}`,
                    );
                }
            }),
        );
    }
}

export interface ItemMarkRequest {
    key: string;
    mark: boolean;
    pids: number[];
}
